import React, { useEffect, useState } from 'react';
import { useContext } from 'react';
import { DataContext } from '../../context/DataContext';
import { debitoAutomaticoDefault, polizaDefault } from '../../data/data';
import http from '../../services/http';
import { endPoints } from '../../utils/constanst';
import DivRow from '../controls/DivRow';
import InputSelect from '../controls/InputSelect';
import SwitchButton from '../controls/SwitchButton';
import Modal from 'react-modal';
import { customStyles } from '../../utils/constanst';
import { ImgAlert, ImgAlertOk, ImgFileDownload } from '../../svg';
import Input from '../controls/Input';


const DebitoAutomatico = ({ location, history, aseguradoId, direccion, direccionCobro, pais = 505, cnpoliza, reference, transactionId, datosTarjeta = {}, ...rest }) => {

    const [data, setData] = useState({
        ...debitoAutomaticoDefault,
        pais: pais,
        viewTerminos: false,
        viewFinalizarDebito: false,
        viewFinalizar: false,
        showDialogPagoSuccess: false,
        showDialogGracias: false,
        showDialogConfirmAddress: false,
        fail: false,
        banks: []
    });


    useEffect(() => {

        http(endPoints.banks).get()
            .then(banks => {
                setData({ ...data, direccionCobro: direccion, banks: banks })
            });

    }, [rest.policyId]);

    const changeHandler = event => {
        //console.log(event.target.value);
        setData({ ...data, [event.target.name]: event.target.value });
    }

    const getBanks = () => {

        if (data.pais === 505) {
            let locals = ['0', '5333', '5334', '5335', '1', '71159', '5387', '5418'];
            return data.banks.filter(x => locals.some(s => s === x.value));
        }
        return data.banks;
    }

    const handleSubmit = () => {
        let result = document.querySelector('form').reportValidity();

        if (data.acepta === false) {
            openModalFinalizar();
            return;
        }


        if (!result) return;

        console.log(cnpoliza);
        console.log(transactionId);
        console.log(datosTarjeta);

        http(endPoints.paymentUpdate).post({
             tarjeta: datosTarjeta.cardNumber
            , tipoTarjeta: data.tipoTarjeta ? 'TR' : 'TZ'
            , correo: datosTarjeta.email
            , celular: datosTarjeta.celular
            , Asegurado: datosTarjeta.cardHolder
            , Vencimiento: datosTarjeta.expirationDate
            , Poliza: cnpoliza,
            transactionId: transactionId
        }).then(r => {
            openModalFinalizarDebito();
        }).catch(ex => { openModalFaild(); });
    };



    const closeModalTeminos = () => setData({ ...data, viewTerminos: false });
    const openModalTeminos = () => setData({ ...data, viewTerminos: true });

    const openModalFinalizarDebito = () => setData({ ...data, viewFinalizarDebito: true });
    const closeModalFinalizarDebito = () => { setData({ ...data, viewFinalizarDebito: false }); openModalConfirmarDireccion(); };

    const openModalConfirmarDireccion = () => setData({ ...data, showDialogConfirmAddress: true });

    const openModalGracias = () => setData({ ...data, showDialogGracias: true });
    const closeModalGracias = () => { setData({ ...data, showDialogGracias: false }); gotoHome(); };


    const openModalFinalizar = () => setData({ ...data, viewFinalizar: true });
    const closeModalFinalizar = () => { setData({ ...data, viewFinalizar: false }); openModalConfirmarDireccion(); };

    const openModalFaild = () => setData({ ...data, faild: true });
    const closeModalFaild = () => setData({ ...data, faild: false });

    const gotoHome = () => {
        //setPoliza({ ...polizaDefault, ...debitoAutomaticoDefault, viewTerminos: false, viewFinalizarDebito: false, viewFinalizar: false, showDialogPagoSuccess: false, showDialogConfirmAddress: false, fail: false });
        history.push('/');
    }

    const closeConfirmAddress = () => {
        setData({ ...data, showDialogConfirmAddress: false });
        openModalGracias();
        if (aseguradoId != null && direccion != direccionCobro) {
            http(endPoints.updateEnteAddress(aseguradoId)).put({ id: aseguradoId, direccionCobro: direccionCobro });
        }

    }



    return (
        <div className="layout">
            <div className="responsieve">
                <div className="reponsive-width-12">
                    <div>
                        <p className=" txt-center" >¿Acepta la tarjeta que utilizó sea guardada para el pago de las cuotas siguientes?</p>
                    </div>
                </div>
                <div className="reponsive-width-12">
                    <form action="">
                        <SwitchButton value={data.acepta} onClick={value => setData({ ...data, acepta: value })} />
                        <SwitchButton label="Tipo tarjeta" si="Débito" no="Crédito" value={data.tipoTarjeta} onClick={value => setData({ ...data, tipoTarjeta: value })} />
                        <InputSelect label='País' value={data.pais} field='pais' dataProvider='paises' onChange={changeHandler} />
                        <InputSelect label='Banco emisor' value={data.bancoEmisor} field='bancoEmisor' dataProvider={getBanks} onChange={changeHandler} />
                    </form>
                </div>
                <div className="reponsive-width-12">
                    <p>Recibirá el comprobante del medio de pago a estos <br />datos en caso de haber autorizado el cambio.</p>
                </div>
                <div className="align-r">
                    <DivRow width='100%'>
                        <button className="control-button-btn btn-next"
                            type="button"
                            onClick={handleSubmit}
                        >Siguiente</button>
                    </DivRow>
                </div>
                <div className="text-right">
                    <p onClick={openModalTeminos} className="a-link">Ver terminos y condiciones</p>
                </div>
                <Modal
                    isOpen={data.viewTerminos}
                    onRequestClose={closeModalTeminos}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal"
                >
                    <div className="dialog-center-content">
                        <div className="fontsize14">
                            <h3 className="h3">Términos y condiciones</h3>

                            <h5 className="lfesm">Actualización de medio de pago</h5>

                            <p>
                                De confirmar la actualización de su medio de pago autoriza a <strong> Seguros LAFISE</strong> a realizar débitos automáticos a la tarjeta indicada en concepto del pago de la prima de la póliza antes descrita y sus renovaciones; así mismo autoriza debitar toda prima originada por adendos, inclusiones, reinstalaciones de suma asegurada, entre otros.
                            </p>

                            <p>
                                En caso que la entidad financiera rechace el débito a tarjeta de crédito/débito, autoriza a dicha entidad para que suministre a <strong> Seguros LAFISE</strong> otra tarjeta autorizada con disponibilidad de saldo.
                            </p>

                            <p>
                                Entiende y acepta que conforme lo establecido en el artículo 78 de la ley 733 "Ley general de Seguros, Reaseguros y Fianzas" debe mantener su póliza al día, de lo contrario, si al momento de la ocurrencia de un siniestro se encuentra en mora, su reclamo no tendrá cobertura.
                            </p>
                        </div>
                    </div>

                    <div className="dialog-center-content">
                        <button type="button" className="control-button-btn btn-color-primary" onClick={closeModalTeminos}>Entendido</button>
                    </div>
                </Modal>
                <Modal
                    isOpen={data.viewFinalizar}
                    onRequestClose={closeModalFinalizar}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal"
                >
                    <div className="dialog-center-content">
                        <p>!Muchas gracias por su compra¡</p>
                    </div>
                    <div className="dialog-center-content">
                        <p>Su pago fue un éxito</p>
                    </div>
                    <div className="dialog-center-content">
                        <ImgAlertOk />
                    </div>
                    <div className="dialog-center-content">
                        <p>Referencia: <b>{reference}</b></p>
                    </div>
                    <div className="dialog-center-content">
                        <p>Póliza: <b>{cnpoliza}</b></p>
                    </div>
                    <h3 className="txt-primary">Estimado cliente, debe contestar a cada una de las preguntas antes de continuar</h3>
                    <div className="dialog-center-content">
                        <button type="button" className="control-button-btn btn-color-primary" onClick={closeModalFinalizar}>Entendido</button>
                    </div>
                </Modal>
                <Modal
                    isOpen={data.viewFinalizarDebito}
                    onRequestClose={closeModalFinalizarDebito}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal"
                >
                    <div className="dialog-center-content">
                        <div className="fontsize14" style={{ 'padding-left': 50, 'padding-right': 50 }}>
                            <h3 className="h3 text-center">¡Muchas gracias por aceptar el débito automático de su póliza!</h3>

                            <h5 className="text-center">Su pago fue un éxito </h5>
                            <div className="dialog-center-content">
                                <ImgAlertOk />
                            </div>
                            <p>
                                A partir de ahora las cuotas de su seguro serán debitadas de la tarjeta ingresada.
                            </p>
                            <p>
                                Le enviaremos el comprobante de la actualización de su medio de pago.
                            </p>
                        </div>
                    </div>

                    <div className="dialog-center-content">
                        <button type="button" className="control-button-btn btn-color-primary" onClick={closeModalFinalizarDebito}>Finalizar</button>
                    </div>

                </Modal>

                <Modal
                    isOpen={data.fail}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal"
                >
                    <h2 className="txt-primary txt-center">
                        Error al procesar el pago
                    </h2>
                    <div className="dialog-center-content">
                        <ImgAlert />
                    </div>
                    <h5 className="txt-muted">No hemos podido procesar su solicitud, actualice su método de pago o proporcione otro e inténtelo nuevamente.</h5>
                    <h5 className="txt-muted">Si desea que un ejecutivo de Seguro LAFISE lo contante para continuar con la gestión vía telefónica de clic en ¨Contáctenme¨</h5>
                    <div className="dialog-center-content">
                        <button type="button" className="control-button-btn btn-color-primary" onClick={closeModalFaild}>Entendido</button>
                    </div>
                </Modal>

                <Modal
                    isOpen={data.showDialogConfirmAddress}
                    onRequestClose={closeConfirmAddress}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal"
                >
                    <div className="dialog-center-content">
                        <h2 className="txt-primary">Confirme su método de envío</h2>

                    </div>

                    <Input type="textarea" label='Confirme la dirección a la cual desea su envío' field='direccionCobro' value={data.direccionCobro} onChange={changeHandler} />
                    <br />
                    <div className="dialog-center-content">
                        <button type="button" className="control-button-btn btn-color-primary" onClick={closeConfirmAddress}>Confirmar</button>
                    </div>
                </Modal>



                <Modal
                    isOpen={data.showDialogGracias}
                    onRequestClose={closeModalGracias}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal"
                >
                    <div className="dialog-center-content">
                        <div className="fontsize14" style={{ 'padding-left': 50, 'padding-right': 50 }}>
                            <h3 className="h3 lfesm text-center">¡Gracias por confiar en seguro LAFISE!</h3>

                            <div className="dialog-center-content">
                                <ImgFileDownload />
                            </div>
                            <p>
                                Te llamaremos para coordinar la entrega de póliza; envío solo aplica a la ciudad/municipio de Managua, resto del país debe retirar en cualquier sucursal de Banco LAFISE Bancentro
                            </p>

                        </div>
                    </div>

                    <div className="dialog-center-content">
                        <button type="button" className="control-button-btn btn-color-primary" onClick={closeModalGracias}>Finalizar</button>
                    </div>


                </Modal>


                <Modal
                    isOpen={data.faild}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal"
                >
                    <h2 className="txt-primary txt-center">
                        Error al procesar el pago
                    </h2>
                    <div className="dialog-center-content">
                        <ImgAlert />
                    </div>
                    <h5 className="txt-muted">No hemos podido procesar su solicitud, actualice su método de pago o proporcione otro e inténtelo nuevamente.

                        Si desea que un ejecutivo de Seguro LAFISE lo contante para continuar con la gestión vía telefónica de clic en ¨Contáctenme¨
                    </h5>
                    <div className="dialog-center-content">
                        <button type="button" className="control-button-btn btn-color-primary" onClick={closeModalFaild}>Entendido</button>
                    </div>
                </Modal>
            </div>
        </div>
    );
}

export default DebitoAutomatico;
